var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var EventCardSectionItem = /** @class */ (function (_super) {
    __extends(EventCardSectionItem, _super);
    function EventCardSectionItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EventCardSectionItem.prototype.render = function () {
        return (React.createElement("div", { className: "rj-ev-list__ev-card__section-item " + (this.props.className || ""), "data-uat": "div-ev-list-ev-card-section-item" }, this.props.content));
    };
    return EventCardSectionItem;
}(React.PureComponent));
export { EventCardSectionItem };
//# sourceMappingURL=EventCardSectionItem.js.map